import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {injectIntl} from "react-intl";

import template from './../../templates/Calendar/CalendarControl.rt';

class CalendarControl extends Component {
  static propTypes = {
    click: PropTypes.func.isRequired,
    month: PropTypes.number.isRequired,
    year: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);

    const {intl} = this.props;
    const m = moment({year: this.props.year, month: this.props.month, day: 1}).locale(intl.locale.split('-')[0]);
    this.state = {
      year: this.props.year,
      month: this.props.month,
      monthName: m.format('MMMM'),
      selectedDate: this.props.selectedDate,
      days: this.createDaysEntries(m, this.props.selectedDate)
    }
  }

  /***
   *
   * @param {moment} m
   * @param selectedDate
   * @returns {Array}
   */
  createDaysEntries = (m, selectedDate) => {
    let cnt = 0;
    const mom = moment(m);
    let res = [];
    mom.date(1);
    const dayOfWeek = mom.day();
    for (let i = 0; i < dayOfWeek; i++) {
      res.push({day: '', selectedVisibility: 'hidden', key: ('prefix' + i)});
      cnt++;
    }

    const daysInMonth = mom.daysInMonth();
    for (let i = 0; i < daysInMonth; i++) {
      const isSelected = (this.props.month === selectedDate.month() &&
      selectedDate.date() === (i + 1) &&
      selectedDate.year() === this.props.year);
      res.push({day: i + 1, selectedVisibility: isSelected ? 'visible' : 'hidden', key: ('day' + i)});
      cnt++;
    }

    const moreCnt = 7 - (cnt % 7);
    for (let i = 0; moreCnt !== 7 && i < moreCnt; i++) {
      res.push({day: '', selectedVisibility: 'hidden', key: ('postfix' + i)});
    }

    return res;
  }

  /**
   *
   * @param {string} day
   */
  onClick = (day) => {
    if (day === '') {
      return;
    }

    this.props.click(this.state.month, +day);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      days: this.createDaysEntries(moment({
        year: nextProps.year,
        month: this.props.month,
        day: 1
      }), nextProps.selectedDate),
      year: nextProps.year
    });
  }

  render = template
}

export default injectIntl(CalendarControl)
